import {
  isElement,
  hasNode,
  liftNodes,
  getBlockAbove,
} from '@udecode/plate';

export const withMCENormalizer = (editor) => {
  const { normalizeNode } = editor;
  editor.normalizeNode = ([node, path]) => {
    if (isElement(node)) {
      // Lift img elements if wrapped by a paragraph to prevent invalid html nesting.
      // <figure> cannot be inside <p>
      if (node.type && node.type === 'img' && path.length > 1) {
        const [ancestorNode] = getBlockAbove(editor, { at: path });
        if (ancestorNode.type && ancestorNode.type === 'p' && hasNode(editor, path)) {
          liftNodes(editor, { at: path });
        }
      } else {
        normalizeNode([node, path]);
      }
    }
  };

  return editor;
};


